'use strict';

var base = require('base/addressBook/addressBook');

base.updateStateValues = function () {
    var replaceStates = function (country) {
        if(!country){
            country=$(this)
        }
        var currentForm = country.closest('form');
        var currentCountry = country.val();

        currentForm.find('select.js-state-set').hide();
        if (currentCountry) {
            currentForm
                .find(
                    'select.js-state-set[data-for-country=' +
                    currentCountry +
                    ']'
                )
                .show();
        } else {
            currentForm
                .find('select.js-state-set[data-for-country=none]')
                .show();
        }
    };

    var resetStateField = function (){
        replaceStates($(this));       
        var currentForm = $(this).closest('form');
        currentForm.find('select.js-state-set').val('');
        currentForm.find('input.shippingState.js-state-value').val('');
        };


    $('#country').on('change', resetStateField);
    $('[id^=shippingCountry]').on('change', resetStateField);
    $('[id^=billingCountry]').on('change', resetStateField);

    if($('#country').length){
        replaceStates($('#country'));
    }   
    if($('[id^=shippingCountry]').length){
        replaceStates($('[id^=shippingCountry]'));
    }
    if($('[id^=billingCountry]').length){
        replaceStates($('[id^=billingCountry]'));
    }


    $('.btn-show-details').on('click', function () {
        var form = $(this).closest('form');

        if (!form) {
            return;
        }

        var country = form.find('[id*=Country]');

        if (!country) {
            return;
        }

        country = country.val();

        if (country) {
            var state = form.find(
                'select.js-state-set[data-for-country=' + country + ']'
            );

            // Cache state value.
            var stateValue = form.find('input.js-state-value').val();

            // Clear prior selections.
            form.find('select.js-state-set').hide();
            form.find('select.js-state-set').val('');
            form.find('input.js-state-value').val('');
            form.find('select.js-state-set[data-for-country=none]').show();

            // Set cached value if it exists.
            if (stateValue) {
                form.find('input.js-state-value').val(stateValue);

                state.val(stateValue).change();
                state
                    .find('option[value=' + stateValue + ']')
                    .attr('selected', 'selected')
                    .prop('selected', true);

                form.find('select.js-state-set[data-for-country=none]').hide();
                state.show();
            }
        }
        $('.billing-address').removeClass('d-none');
    });

    $('.btn-add-new').on('click', function () {
        var form = $(this).closest('form');

        if (!form) {
            return;
        }

        form.find('select.js-state-set').hide();
        form.find('select.js-state-set').val('');
        form.find('input.js-state-value').val('');
        form.find('select.js-state-set[data-for-country=none]').show();

        var $el = $(this);
        // Handle billing address case
        $('body').trigger('payment:clearAddressForm');
        var $option = $($el.parents('form').find('.addressSelector option')[0]);
        $option.attr('value', 'new');
        var $newTitle = $('#dwfrm_creditCard input[name=localizedNewAddressTitle]').val();
        $option.text($newTitle);
        $option.prop('selected', 'selected');
        $el.parents('[data-address-mode]').attr('data-address-mode', 'new');
        $('.billing-address').removeClass('d-none');
    });

    $('select.js-state-set').on('change', function () {
        var currentForm = $(this).closest('form');
        var currentState = $(this).val();

        currentForm.find('input.js-state-value').val(currentState);
    });
};

base.populateAddressForm = function () {
    if (!$('.payment-form').length) {
        return;
    }

    var currentState = $('.payment-form input.js-state-value').val();
    var currentStateSelect = $(
        '.payment-form .js-state-set option[value="' + currentState + '"]'
    ).parent();
    var currentCountry = currentStateSelect.attr('data-for-country');

    if (currentState.length > 0) {
        $('.payment-form .js-state-set').hide();
        currentStateSelect.show();
    }

    if (currentCountry.length > 0) {
        $('.payment-form select#country').val(currentCountry);
    }
};

/**
 * updates the billing address selector within billing forms
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateCreditCardAddressSelector(order, customer) {
    var shippings = order.shipping;

    var form = $('form[name$=creditCard]')[0];
    var $billingAddressSelector = $('.addressSelector', form);
    var hasSelectedAddress = false;

    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
        $billingAddressSelector.empty();
        // Add New Address option
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order,
            { type: 'billing' }));

        // Separator -
        $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, {
                // className: 'multi-shipping',
                type: 'billing'
            }
        ));

        shippings.forEach(function (aShipping) {
            var isSelected = order.billing.matchingAddressId === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            // Shipping Address option
            $billingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order,
                    {
                        // className: 'multi-shipping',
                        type: 'billing'
                    }
                )
            );
        });

        if (customer.addresses && customer.addresses.length > 0) {
            $billingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = order.billing.matchingAddressId === address.ID;
                hasSelectedAddress = hasSelectedAddress || isSelected;
                // Customer Address option
                $billingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order, { type: 'billing' })
                );
            });
        }
    }

    if (hasSelectedAddress
        || (!order.billing.matchingAddressId && order.billing.billingAddress.address)) {
        // show
        $(form).attr('data-address-mode', 'edit');
    } else {
        $(form).attr('data-address-mode', 'new');
    }

    $billingAddressSelector.show();
}

/**
 * Updates the billing address form values within payment forms without any payment instrument validation
 * @param {Object} order - the order model
 */
function updateCreditCardAddress(order) {
    var billing = order.billing;
    if (!billing.billingAddress || !billing.billingAddress.address) return;

    var form = $('form[name=payment-form]');
    if (!form) return;

    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
    $('input[name$=_city]', form).val(billing.billingAddress.address.city);
    $('input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode);
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .val(billing.billingAddress.address.stateCode);
    $('select[name$=_country]', form).val(billing.billingAddress.address.countryCode.value);
    $('input[name$=_phone]', form).val(billing.billingAddress.address.phone);
    $('input[name$=_email]', form).val(order.orderEmail);
}

/**
 * Validate and update payment instrument form fields
 * @param {Object} order - the order model
 */
function validateAndUpdateCreditCardPaymentInstrument(order) {
    var billing = order.billing;
    if (!billing.payment || !billing.payment.selectedPaymentInstruments
        || billing.payment.selectedPaymentInstruments.length <= 0) return;

    var form = $('form[name=payment-form]');
    if (!form) return;

    var instrument = billing.payment.selectedPaymentInstruments[0];
    $('select[name$=expirationMonth]', form).val(instrument.expirationMonth);
    $('select[name$=expirationYear]', form).val(instrument.expirationYear);
    // Force security code and card number clear
    $('input[name$=securityCode]', form).val('');
    $('input[name$=cardNumber]').data('cleave').setRawValue('');
}

/**
 * Updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateCreditCardAddressFormValues(order) {
    updateCreditCardAddress(order);
    validateAndUpdateCreditCardPaymentInstrument(order);
}

/**
 * clears the billing address form values
 */
function clearCreditCardAddressFormValues() {
    updateCreditCardAddressFormValues({
        billing: {
            billingAddress: {
                address: {
                    countryCode: {}
                }
            }
        }
    });
}


base.selectBillingAddress = function () {
    $('.payment-form .addressSelector').on('change', function () {
        var form = $(this).parents('form')[0];
        var selectedOption = $('option:selected', this);
        var optionID = selectedOption[0].value;

        if (optionID === 'new') {
            // Show Address
            $(form).attr('data-address-mode', 'new');
        } else {
            // Hide Address
            $(form).attr('data-address-mode', 'shipment');
        }

        // Copy fields
        var attrs = selectedOption.data();
        var element;

        Object.keys(attrs).forEach(function (attr) {
            element = attr === 'countryCode' ? 'country' : attr;
            if (element === 'cardNumber') {
                $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
            } else {
                $('[name$=' + element + ']', form).val(attrs[attr]);
            }
        });

        form = $('form[name=payment-form]');
        if (!form) {
            return;
        }

        var country = form.find('[id*=Country]');

        if (!country) {
            return;
        }

        country = country.val();

        if (country) {
            var state = form.find(
                'select.js-state-set[data-for-country=' + country + ']'
            );

            // Cache state value.
            var stateValue = form.find('input.js-state-value').val();

            // Clear prior selections.
            form.find('select.js-state-set').hide();
            form.find('select.js-state-set').val('');
            form.find('input.js-state-value').val('');
            form.find('select.js-state-set[data-for-country=none]').show();

            // Set cached value if it exists.
            if (stateValue) {
                form.find('input.js-state-value').val(stateValue);

                state.val(stateValue).change();
                state
                    .find('option[value=' + stateValue + ']')
                    .attr('selected', 'selected')
                    .prop('selected', true);

                form.find('select.js-state-set[data-for-country=none]').hide();
                state.show();
            }
        }
    });
};

base.clearCreditCardForm = function () {
    $('body').on('payment:clearAddressForm', function () {
        clearCreditCardAddressFormValues();
    });
};

module.exports = base;
